import styled from 'styled-components'

import layout from 'constants/layout'

export const StyledWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  max-width: 480px;
  padding: 20px;
  margin: 0 auto;
  text-align: center;
  align-items: center;
  padding-top: 200px;

  @media (max-width: ${layout.mobileWidthResolution}px) {
    padding-top: 50px;
  }
`

interface StyledCircleProps {
  $color: string
}

export const StyledCircle = styled.div<StyledCircleProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background-color: ${({ $color }) => $color};
`
